import * as Stimulus from "@hotwired/stimulus"

/**
 * Makes non-<a> elements behave like links. Intended
 * to make table rows clickable.
 */

export class LinkableController extends Stimulus.Controller {
    static classes = [ "clickable" ];
    static values = {
        'href': String
    };

    connect() {
        if(this.hasClickableClass) {
            this.element.classList.add(...this.clickableClasses);
        }
    }

    navigate(e) {
        if(this.isLinkTag(e)) { return false; }

        Turbo.visit(this.hrefValue);
    }

    isLinkTag(e) {
        return e.target.nodeName === 'A' && e.target.href != undefined;
    }
}
